import PropTypes from 'prop-types';
import OptionButton from './options-button';

const Window = ({
  isLoading,
  onClick,
  preciseTimes,
  timeZone,
  window: {start, end, available, utcOffset, appointmentId},
  ...rest
}) => {
  const selected = rest.selectedWindowStart && rest.selectedWindowStart.isSame(start, 'minute');
  return (
    <OptionButton
      className={(available ? 'available' : 'unavailable', 'time-window')}
      disabled={isLoading || !available}
      highlighted={available}
      onClick={selected || !available ? () => {} : () => onClick({start, end, utcOffset, appointmentId})}
      selected={!!selected}>
      <p className={'text-sm font-bold py-2 text-nowrap'}>{formattedWindow({start, end, preciseTimes, timeZone})}</p>
    </OptionButton>
  );
};

function formattedWindow({start, end, preciseTimes, timeZone}) {
  if (preciseTimes) {
    return start.tz(timeZone).format('LT');
  } else {
    return `${start.tz(timeZone).format('LT')} - ${end.tz(timeZone).format('LT')}`;
  }
}

Window.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  window: PropTypes.object,
};

Window.defaultProps = {
  isLoading: false,
  available: true,
  onClick: () => {},
  window: {start: {format: () => ''}, end: {format: () => ''}},
};

export default Window;
